module.exports = __webpack_public_path__ + "7b66831ce156de757d9bc34d4744da93.svg";